import { Address, encodeAbiParameters, Hex } from 'viem'

export const NONCE = 1n

export const encodeOwners = (owners: Address[]): Hex[] =>
  owners.map((owner) => encodeAbiParameters([{ type: 'address' }], [owner]))
